import React, { useEffect, useRef, useState } from 'react';
import { useMap, Marker, Popup, Polyline } from 'react-leaflet';
import { antPath } from 'leaflet-ant-path';
import L from 'leaflet';

import startPng from "../Images/start.png";
import parkPng from "../Images/park.png";
import endPng from "../Images/end.png";
import pointPlay from '../Images/pointPlay.png';

import './Count2.css';

export default function Count2({ list, play, onFinish, onPlay, speed, restart, showParking }) {
    const map = useMap();
    const [count, setCount] = useState(-1);
    const timerRef = useRef(null);
    const markerRef = useRef(null);
    const popupRef = useRef(null);
    const sliderContainerRef = useRef(null);

    const [path, setPath] = useState(null);

    // جلوگیری از انتقال رویدادهای Drag نقشه به اسلایدر
    useEffect(() => {
        if (sliderContainerRef.current) {
            L.DomEvent.disableClickPropagation(sliderContainerRef.current);
            L.DomEvent.disableScrollPropagation(sliderContainerRef.current);
        }
    }, []);

    const createRouteAnimation = (data) => {
        if (map && path && map.hasLayer(path)) {
            map.removeLayer(path);
        }
        const route = data.points.map(item => [item.latitude, item.longitude]);
        const paths = antPath(route, {
            delay: 1000,
            dashArray: [10, 20],
            weight: 5,
            color: "#0000FF",
            pulseColor: "#FFFFFF",
            paused: data.paused,
            reverse: data.reverse,
            hardwareAccelerated: true
        });
        if (map) {
            map.addLayer(paths);
        }
        return paths;
    };

    useEffect(() => {
        if (play === "off") {
            if (map && path && map.hasLayer(path)) map.removeLayer(path);
        } else if (play === "play") {
            if (map && path && map.hasLayer(path)) map.removeLayer(path);
            setPath(createRouteAnimation({ points: list, paused: false, reverse: false }));
        } else if (play === "show") {
            setPath(createRouteAnimation({ points: list, paused: true, reverse: false }));
        }
    }, [play]);

    useEffect(() => {
        if (list && list.length > 0 && play === "show") {
            if (map && path && map.hasLayer(path)) map.removeLayer(path);
            setPath(createRouteAnimation({ points: list, paused: true, reverse: false }));
        }
    }, [list]);

    useEffect(() => {
        if (restart > 0 && count !== -1) {
            setCount(0);
            if (onPlay) onPlay(0);
        }
    }, [restart]);

    // شروع پخش از صفر
    useEffect(() => {
        if (play !== "off" && list && list.length > 0 && count === -1) {
            setCount(0);
            if (onPlay) onPlay(0);
        }
    }, [play, list]);

    // کنترل تایمر پخش خودکار
    useEffect(() => {
        if (play !== "play" || !list || list.length === 0) return;

        timerRef.current = setInterval(() => {
            setCount((c) => {
                if (c >= list.length - 1) {
                    clearInterval(timerRef.current);
                    if (onFinish) onFinish();
                    return list.length - 1;
                } else {
                    const nextCount = c + 1;
                    if (onPlay) onPlay(nextCount);
                    return nextCount;
                }
            });
        }, speed || 500);

        return () => clearInterval(timerRef.current);
    }, [play, list, speed]);

    // باز کردن پاپ‌آپ و در صورت نیاز متمرکز شدن روی مارکر
    useEffect(() => {
        if (markerRef.current) {
            markerRef.current.openPopup();
        }
    }, [count]);

    // رویداد تغییر دستی اسلایدر توسط کاربر
    const handleSliderChange = (e) => {
        const selectedIndex = parseInt(e.target.value, 10);
        setCount(selectedIndex);
        if (onPlay) onPlay(selectedIndex);
    };

    const currentItem = list?.[count];

    // مختصات مسیر طی شده تا این لحظه (بهینه‌سازی در یک Polyline واحد)
    const completedPath = (list && count > 0)
        ? list.slice(0, count + 1).map(item => [item.latitude, item.longitude])
        : [];

    return (
        <>
            {/* ۱. نمایش مارکرهای شروع و توقف‌ها */}
            {play !== "off" && list && list.map((item, index) => (
                <React.Fragment key={(item.ime || 'pt') + "-onreport-" + index}>
                    {index === 0 && (
                        <Marker
                            position={[item.latitude, item.longitude]}
                            icon={new L.Icon({
                                iconUrl: startPng,
                                iconSize: [50, 50],
                                iconAnchor: [25, 45],
                                popupAnchor: [0, -45]
                            })}
                        >
                            <Popup>
                                <div>{`${item.dtFa || ''} ${item.time || ''}`}</div>
                            </Popup>
                        </Marker>
                    )}

                    {item.stopTime !== "0" && item.stopTime != null && showParking && (
                        <Marker
                            position={[item.latitude, item.longitude]}
                            icon={new L.Icon({
                                iconUrl: parkPng,
                                iconSize: [50, 50],
                                iconAnchor: [25, 45],
                                popupAnchor: [0, -45]
                            })}
                        >
                            <Popup>
                                <div>{`${item.dtFa || ''} ${item.time || ''}`}</div>
                            </Popup>
                        </Marker>
                    )}
                </React.Fragment>
            ))}

            {/* ۲. مارکر نقطه پایان */}
            {play !== "off" && list && list.length >= 2 && (
                <Marker
                    position={[list[list.length - 1].latitude, list[list.length - 1].longitude]}
                    icon={new L.Icon({
                        iconUrl: endPng,
                        iconSize: [50, 50],
                        iconAnchor: [25, 45],
                        popupAnchor: [0, -45]
                    })}
                >
                    <Popup>
                        <div>
                            {`${list[list.length - 1].dtFa || ''} ${list[list.length - 1].time || ''}`}
                        </div>
                    </Popup>
                </Marker>
            )}

            {/* ۳. رسم مسیر طی‌شده (سبز) و مارکر موقعیت فعلی */}
            {play !== "off" && count > -1 && currentItem && (
                <>
                    {completedPath.length > 1 && (
                        <Polyline positions={completedPath} color="#198754" weight={6} />
                    )}

                    <Marker
                        ref={markerRef}
                        position={[currentItem.latitude, currentItem.longitude]}
                        icon={new L.Icon({
                            iconUrl: pointPlay,
                            iconSize: [45, 45],
                            iconAnchor: [22, 40],
                            popupAnchor: [0, -40]
                        })}
                    >
                        <Popup ref={popupRef}>
                            <div className="popupMarker2" dir="rtl">
                                <div className="row mt-2">
                                    <div className="col">
                                        📅 زمان: <span className='fw-bold'>{`${currentItem.dtFa || ''} ${currentItem.time || ''}`}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        🔑 سوئیچ: <span className='fw-bold'>{currentItem.switch === 1 || currentItem.shock === 1 ? "روشن" : "خاموش"}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        💨 سرعت: <span className='fw-bold'>{currentItem.speed === 0 ? "ساکن" : `${currentItem.speed} km/h`}</span>
                                    </div>
                                </div>
                                {'battery' in currentItem && (
                                    <div className="row mt-2">
                                        <div className="col">
                                            🔋 باتری: <span className='fw-bold'>{currentItem.battery}%</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Popup>
                    </Marker>
                </>
            )}

            {/* ۴. نوار اسکرول افقی (Slider) شناور روی نقشه */}
            {play !== "off" && list && list.length > 0 && (
                <div
                    ref={sliderContainerRef}
                    className="position-absolute start-50 translate-middle-x px-3 py-2 bg-white bg-opacity-75 rounded-4 shadow"
                    style={{
                        bottom: '225px',
                        zIndex: 1000,
                        width: '90%',
                        maxWidth: '500px',
                        backdropFilter: 'blur(6px)',
                        direction: 'ltr'
                    }}
                    // جلوگیری از ارسال رویدادهای درگ و کلیک به نقشه زیرین
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                    onDoubleClick={(e) => e.stopPropagation()}
                >
                    <div className="d-flex justify-content-between align-items-center mb-1 small text-dark fw-bold" dir="rtl">
                        <span>{currentItem ? `${currentItem.dtFa || ''} ${currentItem.time || ''}` : 'مسیر حرکت'}</span>
                        <span>{count + 1} از {list.length}</span>
                    </div>

                    <input
                        type="range"
                        className="form-range"
                        min={0}
                        max={list.length - 1}
                        value={count >= 0 ? count : 0}
                        onChange={handleSliderChange}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            )}
        </>
    );
}
